<template>
  <gg-card class="fill-height">
    <gg-card-header>
      {{ title }}
    </gg-card-header>
    <gg-card-text>
      <v-row v-if="type === 'month'">
        <v-col cols="12">
          Reporting Period: <b>{{ reportingPeriod }}</b>
        </v-col>
        <v-col cols="12">
          Signups this Period: <b>{{ overview.signUps }}</b>
        </v-col>
        <v-col cols="12">
          Payout per Signup: <b>{{ moneyFormat(overview.payout) }}</b>
        </v-col>
        <v-col cols="12">
          Earnings this Period: <b>{{ moneyFormat(overview.earnings) }}</b>
        </v-col>
      </v-row>
      <v-row v-if="type === 'year'">
        <v-col cols="12">
          Reporting Period: <b>{{ reportingPeriod }}</b>
        </v-col>
      </v-row>
      <v-row v-if="type === 'lifetime'">
        <v-col cols="12">
          Reporting Period: <b>{{ reportingDate }}</b>
        </v-col>
      </v-row>
    </gg-card-text>
  </gg-card>
</template>

<script>
import { mapGetters } from 'vuex'
import format from 'date-fns/format'
import parse from 'date-fns/parse'
import { moneyFormat } from '@/helpers/helpers'

export default {
  name: 'AccountOverview',
  props: {
    type: {
      type: String,
      required: true,
      default: 'month'
    },
    title: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      reportingDate: 'affiliates/reportingDate',
      overview: 'affiliates/overview'
    }),
    reportingPeriod () {
      const dateFormat = this.type === 'year' ? 'yyyy' : 'MMMM yyyy'
      const newDate = parse(this.reportingDate, 'yyyy-MM', new Date())
      return format(newDate, dateFormat)
    }
  },
  methods: {
    moneyFormat
  }
}
</script>

<style scoped>

</style>
